import React, { useEffect, useState, useRef } from "react";
import backgroundfee from "../../assets/video/feebackground.mov";
import logoImg from "../../assets/images/Logo.png";
import doneImg from "../../assets/images/done.gif";

import { Dialog } from "@material-ui/core";
import {
  searchSchoolByIdForPayment,
  initiatePaymentRequest,
} from "../../api/schools";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router";
import { CircularProgress } from "@material-ui/core";
import { BASE_URL } from "../../util/constants";
import axios from "axios";
import { encrypt, decrypt } from "../../util/aes-128-encrypt";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PaymentLayer() {
  const submitForm = useRef(null);
  const [hiddenXml, setHiddenXML] = useState("xml");
  const [cbdURL, setCbdUrl] = useState("cbd");
  const [clientId, setClientId] = useState("clientId");

  const schoolId = useQuery().get("schoolId");
  const amount = useQuery().get("amount");
  const orderId = useQuery().get("orderId");

  useEffect(() => {
    initiatePaymentRequest(schoolId, amount, orderId).then((data) => {
      setHiddenXML(data.message);
      setCbdUrl(data.cbdUrl);
      setClientId(data.clientId);
      submitForm.current.submit();
    });
  }, []);

  return (
    <div className="mainDiv">
      <form ref={submitForm} name="redirect" action={cbdURL} method="POST">
        <input type="hidden" name="c" value={hiddenXml} />
        <input type="hidden" name="clientCode" value={clientId} />
        <input type="submit" id="btnSubmit" value="Please wait" disabled />
      </form>
    </div>
  );
}
